import { Folder } from '@Models';
import {
  buildEntityActionState,
  EntityActionState,
} from '../EntityActionState';

export type FolderState = EntityActionState<Folder>;

export const buildFolderState = (data: Partial<FolderState> = {}) =>
  buildEntityActionState<Folder>(data);

export enum FolderActionState {
  Edit = 0,
  Delete = 1,
  AddArmyList = 2,
  Share = 3,
  ToEvent = 4,
}
